import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component( {
   selector: 'lib-copy-dialog',
   templateUrl: './copy-dialog.component.html',
   styleUrls: ['./copy-dialog.component.scss'],
})
export class CopyDialogComponent {
   message: string;
   column: string;

   constructor(
      public dialogRef: MatDialogRef<CopyDialogComponent>,
      @Inject( MAT_DIALOG_DATA ) public data: any,
      private clipboard: Clipboard,
      private snackbar: MatSnackBar
   ) {
      this.message = (data.message) ? data.message : 'Hi!';
      this.column = data.column || '';
   }

   copy() {
      this.clipboard.copy( this.message );
      this.snackbar.open( 'Copied!', '', { duration: 1000 });
      this.dialogRef.close();
   }

   openWindow(){
      if(this.column == 'hawb'){
         let url = window.location.origin+"/manage/shipments/"+this.message
         window.open(url);
         this.dialogRef.close();
      }

   }
}
